// import { FunctionComponent, useContext, useEffect, useState, useRef } from "react";
// import { toast } from "react-toastify";
// import styles from "./DashboardHeader.module.css";
// import images from "../../../assets/images/index";
// import ProfileDropdown from "../dropdown/profile-dropdown/ProfileDropdown";
// import { CircularProgress, Dialog, Menu } from "@mui/material";
// import { GrClose } from "react-icons/gr";
// import { IoMdNotificationsOutline, IoMdSettings } from "react-icons/io";
// import { MdMenu } from "react-icons/md";
// import SearchDropdown from "../dropdown/search-dropdown/SearchDropdown";
// import NotificationComponent from "../notification/NotificationComponent";
// import { globalContext } from "../../../Provider/AppProvider";
// import { useLazyQuery } from "@apollo/client";
// import { GLOABAL_SEARCH, GLOABAL_SEARCH_BY_LOGITIX_USER, GLOABAL_SEARCH_BY_Marketing_USER } from "./api/SearchUserandTickets";
// import PopupComponent from "../success-popup/PopupComponent";
// import { CustomPaperComponent, roles } from "../../../helper";
// import { useLocation, useNavigate } from "react-router-dom";
// import ChangePassword from "../change-password/ChangePassword";

// interface headerProps {
//   loadingUserProfile: boolean;
//   onMenuClick?: () => void;      // For hamburger menu toggle (mobile)
//   isSidebarOpen?: boolean;       // Optional, if needed for any icon state (not used here)
// }

// interface NotificationSettings {
//   statusChanges: {
//     pending: boolean;
//     confirmed: boolean;
//     fulfilled: boolean;
//     cancelled: boolean;
//     refunded: boolean;
//   };
//   toastDuration: number;
//   soundEnabled: boolean;
//   soundTone: string;
//   bulkUpdatesPeriod: string;
//   newOrdersStatus: string;
// }

// const DashboardHeader: FunctionComponent<headerProps> = ({ loadingUserProfile, onMenuClick }) => {
//   const { searchIcon, notificationIcon, DefaultProfile } = images;
//   const [anchorEl, setAnchorEl] = useState(null);
//   const { globalState, handleGlobalState } = useContext<any>(globalContext);
//   const [showNotificationPopup, setShowNotificationPopup] = useState(false);
//   const [showSettingsPopup, setShowSettingsPopup] = useState(false);
//   const notificationRef = useRef<HTMLDivElement>(null);
//   const settingsRef = useRef<HTMLDivElement>(null);
//   const notificationButtonRef = useRef<HTMLDivElement>(null);
//   const settingsButtonRef = useRef<HTMLDivElement>(null);
//   const hasNotificationEffectRun = useRef(false);
//   const [searchText, setSearchText] = useState<string>("");
//   const [showSearch, setShowSearch] = useState<boolean>(false);
//   const [searchResult, setSearchResult] = useState<any>("");
//   const [finalsearch, setFinalsearch] = useState<string>("");
//   const [userProfile, setUserProfile] = useState<string>("");
//   const baseURL = process.env.REACT_APP_FRONTEND_URL;
//   const [email, setEmail] = useState<boolean>(false);
//   const StyledComponent = CustomPaperComponent();
//   const [openSuccessDialog, setOpenSuccessDialog] = useState<boolean>(false);
//   const [openDialog, setOpenDialog] = useState(false);
//   const { pathname } = useLocation();
//   const navigate = useNavigate();

//   // Audio context for sounds (unchanged)
//   const audioContextRef = useRef<AudioContext | null>(null);
//   const currentOscillatorRef = useRef<OscillatorNode | null>(null);
//   const currentGainRef = useRef<GainNode | null>(null);

//   const stopCurrentSound = () => {
//     if (currentOscillatorRef.current) {
//       try {
//         currentOscillatorRef.current.stop();
//       } catch (e) {}
//       currentOscillatorRef.current = null;
//       currentGainRef.current = null;
//     }
//   };

// const playBeep = (
//   frequency: number,
//   duration: number = 1.5,
//   volume: number = 0.25,
//   type: OscillatorType = "triangle"
// ) => {
//   try {
//     const AudioContextClass =
//       window.AudioContext || (window as any).webkitAudioContext;

//     if (!audioContextRef.current) {
//       audioContextRef.current = new AudioContextClass();
//     }

//     const audioContext = audioContextRef.current;

//     const oscillator = audioContext.createOscillator();
//     const gainNode = audioContext.createGain();

//     oscillator.connect(gainNode);
//     gainNode.connect(audioContext.destination);

//     oscillator.type = type;
//     oscillator.frequency.value = frequency;

//     // louder sound
//     gainNode.gain.setValueAtTime(volume, audioContext.currentTime);

//     // smooth fade out
//     gainNode.gain.exponentialRampToValueAtTime(
//       0.0001,
//       audioContext.currentTime + duration
//     );

//     if (audioContext.state === "suspended") {
//       audioContext.resume();
//     }

//     oscillator.start();
//     oscillator.stop(audioContext.currentTime + duration);
//   } catch (err) {
//     console.log(err);
//   }
// };

// const playSoundPreview = (tone: string) => {
//   if (!notificationSettings.soundEnabled) return;

//   switch (tone) {

//     // PREMIUM APPLE STYLE
//     case "gentle-chime":
//       playBeep(523, 1.2, 0.22, "triangle");
//       setTimeout(() => playBeep(659, 1.2, 0.22, "triangle"), 400);
//       setTimeout(() => playBeep(784, 1.5, 0.22, "triangle"), 800);
//       break;

//     // LOUD ALERT
//     case "alert-beep":
//       playBeep(950, 0.8, 0.35, "square");
//       setTimeout(() => playBeep(950, 0.8, 0.35, "square"), 900);
//       setTimeout(() => playBeep(950, 0.8, 0.35, "square"), 1800);
//       break;

//     // SOFT BELL
//     case "soft-bell":
//       playBeep(620, 3, 0.28, "sine");
//       break;

//     // QUICK MODERN PING
//     case "quick-ping":
//       playBeep(1200, 0.6, 0.30, "triangle");
//       setTimeout(() => playBeep(980, 0.6, 0.25, "triangle"), 300);
//       break;

//     // BIG URGENT ALARM
//     case "urgent-alarm":
//       playBeep(880, 0.7, 0.4, "square");
//       setTimeout(() => playBeep(660, 0.7, 0.4, "square"), 700);
//       setTimeout(() => playBeep(880, 0.7, 0.4, "square"), 1400);
//       setTimeout(() => playBeep(660, 0.7, 0.4, "square"), 2100);
//       break;

//     default:
//       playBeep(700, 1.5, 0.25, "triangle");
//   }
// };

//   const playNotificationSound = (tone: string) => {
//     if (!notificationSettings.soundEnabled) return;
//     playSoundPreview(tone);
//   };

//   const [notificationSettings, setNotificationSettings] = useState<NotificationSettings>({
//     statusChanges: {
//       pending: true,
//       confirmed: true,
//       fulfilled: true,
//       cancelled: true,
//       refunded: true,
//     },
//     toastDuration: 5,
//     soundEnabled: true,
//     soundTone: "gentle-chime",
//     bulkUpdatesPeriod: "All",
//     newOrdersStatus: "all",
//   });

//   const open = Boolean(anchorEl);

//   const [globalSearch] = useLazyQuery(GLOABAL_SEARCH, { fetchPolicy: "no-cache", onCompleted: (data) => setSearchResult(data) });
//   const [globalSearchByLogitixUser] = useLazyQuery(GLOABAL_SEARCH_BY_LOGITIX_USER, { fetchPolicy: "no-cache", onCompleted: (data) => setSearchResult(data) });
//   const [globalSearchByMarketingUser] = useLazyQuery(GLOABAL_SEARCH_BY_Marketing_USER, { fetchPolicy: "no-cache", onCompleted: (data) => setSearchResult(data) });

//   const handleClick = (event: any) => setAnchorEl(event.currentTarget);
//   const handleClose = () => setAnchorEl(null);

//   const handleNotificationClick = () => {
//     setShowNotificationPopup(!showNotificationPopup);
//     setShowSettingsPopup(false);
//   };

//   const handleSettingsClick = () => {
//     setShowSettingsPopup(!showSettingsPopup);
//     setShowNotificationPopup(false);
//   };

//   const handleClosePopups = () => {
//     setShowNotificationPopup(false);
//     setShowSettingsPopup(false);
//     stopCurrentSound();
//   };

//   const handleCloseDialogPop = () => {
//     setOpenSuccessDialog(false);
//     navigate("/login");
//   };
//   const handleCloseDialog = () => setOpenDialog(false);

//   const handleStatusChange = (status: keyof NotificationSettings["statusChanges"]) => {
//     setNotificationSettings((prev) => ({
//       ...prev,
//       statusChanges: { ...prev.statusChanges, [status]: !prev.statusChanges[status] },
//     }));
//   };

//   const handleToastDurationChange = (duration: number) => {
//     setNotificationSettings((prev) => ({ ...prev, toastDuration: duration }));
//   };

//   const handleSoundToggle = () => {
//     setNotificationSettings((prev) => ({ ...prev, soundEnabled: !prev.soundEnabled }));
//     if (notificationSettings.soundEnabled) stopCurrentSound();
//   };

//   const handleSoundToneChange = (tone: string) => {
//     setNotificationSettings((prev) => ({ ...prev, soundTone: tone }));
//     playSoundPreview(tone);
//   };

//   const handleBulkUpdatesChange = (period: string) => {
//     setNotificationSettings((prev) => ({ ...prev, bulkUpdatesPeriod: period }));
//   };

//   const handleNewOrdersStatusChange = (status: string) => {
//     setNotificationSettings((prev) => ({ ...prev, newOrdersStatus: status }));
//   };

//   useEffect(() => {
//     if (!globalState.notification.newNotification) return;
//     if (!hasNotificationEffectRun.current) {
//       hasNotificationEffectRun.current = true;
//       return;
//     }

//     if (notificationSettings.soundEnabled) {
//       playNotificationSound(notificationSettings.soundTone);
//     }

//     toast.info("New notification received", {
//       toastId: globalState.notification.newNotification,
//       position: "top-right",
//       autoClose: notificationSettings.toastDuration * 1000,
//       pauseOnHover: true,
//       draggable: true,
//       closeOnClick: true,
//     });
//   }, [globalState.notification.newNotification, notificationSettings.soundEnabled, notificationSettings.soundTone, notificationSettings.toastDuration]);
//   useEffect(() => {
//     return () => {
//       stopCurrentSound();
//       if (audioContextRef.current) audioContextRef.current.close();
//     };
//   }, []);

//   useEffect(() => {
//     const handleClickOutside = (event: MouseEvent) => {
//       if (notificationRef.current && !notificationRef.current.contains(event.target as Node) &&
//           notificationButtonRef.current && !notificationButtonRef.current.contains(event.target as Node)) {
//         setShowNotificationPopup(false);
//       }
//       if (settingsRef.current && !settingsRef.current.contains(event.target as Node) &&
//           settingsButtonRef.current && !settingsButtonRef.current.contains(event.target as Node)) {
//         setShowSettingsPopup(false);
//         stopCurrentSound();
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   const handleSearch = async (searchString: string) => {
//     if (searchString.includes("@")) setEmail(true);
//     if (searchString.trim().length > 2 && !globalState.notification.notificationClicked && !globalState.error.errorClicked) {
//       setShowSearch(true);
//       if (globalState.profile.userRole === roles.ADMIN || globalState.profile.userRole === roles.AFFILIATER_ADMIN) {
//         globalSearch({ variables: { searchText: `${searchString.trim()}%`, searchEvent: `%${searchString.trim()}%` } });
//       } else if (globalState.profile.userRole === "marketing_user") {
//         globalSearchByMarketingUser({ variables: { searchText: `${searchString.trim()}%`, searchEvent: `%${searchString.trim()}%` } });
//       } else {
//         globalSearchByLogitixUser({ variables: { searchText: `${searchString.trim()}%`, searchEvent: `%${searchString.trim()}%` } });
//       }
//     } else {
//       const tempstate = { ...globalState };
//       tempstate.globalSearch.searchtext = "";
//       handleGlobalState(tempstate);
//       setSearchResult([]);
//       setShowSearch(false);
//     }
//   };

//   useEffect(() => {
//     setUserProfile(globalState?.profile?.photo);
//   }, [globalState?.profile?.profileUpdate, globalState?.profile?.photo]);

//   const handleSearchClick = (data: any) => {
//     if (searchText.includes("@")) {
//       setSearchText(data?.u_email_id || data?.a_email_id);
//       setFinalsearch(data?.u_email_id || data?.a_email_id);
//     } else {
//       setSearchText(data?.u_full_name || data?.e_name || data?.lc_name || data?.user?.u_full_name);
//       setFinalsearch(data?.u_full_name || data?.e_name || data?.lc_name || data?.user?.u_full_name);
//     }
//     setShowSearch(false);
//     setEmail(false);
//   };

//   useEffect(() => {
//     const tempState = { ...globalState };
//     handleGlobalState(tempState);
//   }, [globalState.notification.reSettingNotificationCount]);

//   useEffect(() => {
//     const tempstate = { ...globalState };
//     tempstate.globalSearch.searchtext = finalsearch;
//     handleGlobalState(tempstate);
//   }, [finalsearch]);

//   const handleCancel = () => {
//     const tempState = { ...globalState };
//     setSearchText("");
//     setShowSearch(false);
//     setFinalsearch("");
//     setEmail(false);
//     tempState.affiliateNumberOfUsers.numberOfUsers = null;
//     tempState.globalSearch.searchtext = "";
//     tempState.notification.text = "";
//     tempState.notification.notificationClicked = false;
//     tempState.notification.tp_id_array = null;
//     tempState.notification.ticketId = null;
//     tempState.notification.tpId = null;
//     tempState.notification.notificationSearchCancel = !globalState.notification.notificationSearchCancel;
//     tempState.error.text = "";
//     tempState.error.errorClicked = false;
//     tempState.error.approximateTpArray = null;
//     tempState.error.ticketPlacementId = null;
//     tempState.error.userError = false;
//     tempState.soldTickets.emailId = "";
//     tempState.soldTickets.failed = false;
//     handleGlobalState(tempState);
//   };

//   useEffect(() => {
//     setSearchText(globalState.globalSearch.searchtext);
//   }, [globalState.globalSearch.searchtext]);

//   useEffect(() => {
//     if (globalState.notification.text) {
//       setSearchText(globalState.notification.text);
//       const tempState = { ...globalState };
//       tempState.globalSearch.searchtext = globalState.notification.text;
//       handleGlobalState(tempState);
//     } else if (globalState.error.text) {
//       setSearchText(globalState.error.text);
//       const tempState = { ...globalState };
//       tempState.globalSearch.searchtext = globalState.error.text;
//       handleGlobalState(tempState);
//     } else {
//       setSearchText("");
//     }
//   }, [globalState.notification.text, globalState.error.text]);

//   useEffect(() => {
//     if (searchText !== globalState.notification.text && globalState.notification.notificationClicked) {
//       const tempState = { ...globalState };
//       tempState.notification.text = "";
//       tempState.notification.notificationClicked = false;
//       tempState.notification.tp_id_array = null;
//       tempState.notification.ticketId = null;
//       tempState.notification.tpId = null;
//       tempState.notification.notificationSearchCancel = !globalState.notification.notificationSearchCancel;
//       handleGlobalState(tempState);
//     } else if (searchText !== globalState.error.text && globalState.error.errorClicked) {
//       const tempState = { ...globalState };
//       tempState.error.text = "";
//       tempState.error.errorClicked = false;
//       tempState.error.approximateTpArray = null;
//       tempState.error.ticketPlacementId = null;
//       tempState.error.status = "";
//       handleGlobalState(tempState);
//     }
//   }, [searchText]);
// const [isMobile, setIsMobile] = useState(
//   window.innerWidth <= 768
// );


//   return (
//     <div className={styles.dashboardHeader} style={{ display: `${pathname === "/new-list" ? "none" : ""}` }}>
//   {/* Hamburger Menu - only mobile */}
// <div
//   className={styles.menuIconContainer}
//   onClick={onMenuClick}
// >
//   <MdMenu
//     className={styles.hamburgerIcon}
//     size={24}
//   />
// </div>
//       {/* Search Bar (commented out as in original) */}
//       {/* <div className={searchText !== '' ? styles.inSearchText : styles.search}> ... </div> */}

//       {/* Right side: Notification, Settings, Profile */}
//       <div className={styles.profileAndNotification}>
//         <div className={styles.iconButtons}>
//           {/* Notification Icon */}
//           <div className={styles.iconWrapper} onClick={handleNotificationClick} ref={notificationButtonRef}>
//             <div className={styles.iconContainer}>
//               <IoMdNotificationsOutline className={styles.notificationIcon} size={22} />
//               {(globalState.notificationCount.past > 0 || globalState.notificationCount.recent > 0) && (
//                 <div className={styles.notificationBadge} />
//               )}
//             </div>
//           </div>

//           {/* Settings Icon */}
//           <div className={styles.iconWrapper} onClick={handleSettingsClick} ref={settingsButtonRef}>
//             <IoMdSettings className={styles.settingsIcon} size={22} />
//           </div>
//         </div>

//         {/* Custom Notification Popup */}
//         {showNotificationPopup && (
//           <div className={styles.customPopup} ref={notificationRef}>
//             <div className={styles.popupHeader}>
//               <h3>Notifications</h3>
//               <button className={styles.closeBtn} onClick={handleClosePopups}>×</button>
//             </div>
//             <div className={styles.popupContent}>
//               <NotificationComponent
//                 closePopup={handleClosePopups}
//                 preferredPeriod={notificationSettings.bulkUpdatesPeriod as "30D" | "90D" | "12M" | "All"}
//                 statusFilters={notificationSettings.statusChanges}
//               />
//             </div>
//           </div>
//         )}

//         {/* Custom Settings Popup */}
//         {showSettingsPopup && (
//           <div className={styles.customPopup} ref={settingsRef}>
//             <div className={styles.popupHeader}>
//               <h3>Notification Preferences</h3>
//               <button className={styles.closeBtn} onClick={handleClosePopups}>×</button>
//             </div>
//             <div className={styles.popupContent}>
//               {/* Status Changes Section */}
//               <div className={styles.settingsSection}>
//                 <div className={styles.sectionTitle}>Status Changes</div>
//                 <div className={styles.settingRow}>
//                   <label className={styles.settingLabel}>Bulk Updates</label>
//                   <div className={styles.periodGroup}>
//                     {["30D", "90D", "12M", "All"].map((period) => (
//                       <button
//                         key={period}
//                         className={`${styles.periodBtn} ${notificationSettings.bulkUpdatesPeriod === period ? styles.active : ""}`}
//                         onClick={() => handleBulkUpdatesChange(period)}
//                       >
//                         {period}
//                       </button>
//                     ))}
//                   </div>
//                 </div>
//                 <div className={styles.settingRow}>
//                   <label className={styles.settingLabel}>New Orders</label>
//                   <div className={styles.statusGroup}>
//                     <button
//                       className={`${styles.statusBtn} ${notificationSettings.newOrdersStatus === "all" ? styles.active : ""}`}
//                       onClick={() => handleNewOrdersStatusChange("all")}
//                     >
//                       All Users
//                     </button>
//                   </div>
//                 </div>
//                 <div className={styles.settingRow}>
//                   <label className={styles.settingLabel}>Status Transitions</label>
//                   <div className={styles.toggleGroup}>
//                     {(["pending", "confirmed", "fulfilled", "cancelled", "refunded"] as const).map((status) => (
//                       <label key={status} className={styles.toggleItem}>
//                         <span>{status.charAt(0).toUpperCase() + status.slice(1)}</span>
//                         <div className={styles.toggleSwitch}>
//                           <input
//                             type="checkbox"
//                             checked={notificationSettings.statusChanges[status]}
//                             onChange={() => handleStatusChange(status)}
//                           />
//                           <span className={styles.toggleSlider}></span>
//                         </div>
//                       </label>
//                     ))}
//                   </div>
//                 </div>
//               </div>

//               <div className={styles.divider} />

//               {/* Toast Pop-ups Section */}
//               <div className={styles.settingsSection}>
//                 <div className={styles.sectionTitle}>Toast Pop-ups</div>
//                 <div className={styles.settingRow}>
//                   <label className={styles.settingLabel}>Show toast alerts</label>
//                   <div className={styles.durationGroup}>
//                     {[3, 5, 10].map((duration) => (
//                       <button
//                         key={duration}
//                         className={`${styles.durationBtn} ${notificationSettings.toastDuration === duration ? styles.active : ""}`}
//                         onClick={() => handleToastDurationChange(duration)}
//                       >
//                         {duration}s
//                       </button>
//                     ))}
//                   </div>
//                 </div>
//               </div>

//               <div className={styles.divider} />

//               {/* Sound Alert Section */}
//               <div className={styles.settingsSection}>
//                 <div className={styles.sectionTitle}>Sound Alert</div>
//                 <div className={styles.settingRow}>
//                   <div className={styles.soundHeader}>
//                     <span>Sound for new pending orders</span>
//                     <div className={styles.toggleSwitch}>
//                       <input type="checkbox" checked={notificationSettings.soundEnabled} onChange={handleSoundToggle} />
//                       <span className={styles.toggleSlider}></span>
//                     </div>
//                   </div>
//                 </div>
//                 {notificationSettings.soundEnabled && (
//                   <div className={styles.soundTones}>
//                     {["gentle-chime", "alert-beep", "soft-bell", "quick-ping", "urgent-alarm"].map((tone) => (
//                       <button
//                         key={tone}
//                         className={`${styles.toneBtn} ${notificationSettings.soundTone === tone ? styles.active : ""}`}
//                         onClick={() => handleSoundToneChange(tone)}
//                       >
//                         <span>{tone.replace("-", " ").replace(/\b\w/g, (l) => l.toUpperCase())}</span>
//                         <span className={styles.previewText}>Preview</span>
//                       </button>
//                     ))}
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>
//         )}

//         {/* Profile Section */}
//         {loadingUserProfile ? (
//           <div className={styles.profileCircularProgress}>
//             <CircularProgress color="primary" size={30} />
//           </div>
//         ) : (
//           <div className={styles.profile} data-testid="profileClick" onClick={handleClick}>
//             <div className={styles.profileOuterCircle}>
//               <img className={styles.imgIcon} alt="userProfile" src={DefaultProfile} />
//             </div>
//             <div className={styles.userName}>
//               {globalState?.profile?.firstName} {globalState?.profile?.lastName}
//             </div>
//           </div>
//         )}
//       </div>

//       {/* Dropdown Menu for Profile */}
//       <Menu
//         anchorEl={anchorEl}
//         id="account-menu"
//         open={open}
//         onClose={handleClose}
//         transformOrigin={{ horizontal: "left", vertical: "top" }}
//         anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
//         MenuListProps={{ disablePadding: true }}
//       >
//         <ProfileDropdown handleClose={handleClose} setOpenSuccessDialog={setOpenSuccessDialog} setOpenDialog={setOpenDialog} />
//       </Menu>

//       <Dialog open={openSuccessDialog} onClose={handleCloseDialogPop} PaperComponent={StyledComponent}>
//         <PopupComponent
//           handleClose={handleCloseDialogPop}
//           title="Password Updated"
//           subTitle="Your password has been successfully updated. Please sign in to your account."
//         />
//       </Dialog>
//       <Dialog open={openDialog} classes={{ paper: styles.customDialog }}>
//         <ChangePassword handleCloseDialog={handleCloseDialog} setOpenSuccessDialog={setOpenSuccessDialog} />
//       </Dialog>
//     </div>
//   );
// };

// export default DashboardHeader;





import { FunctionComponent, useContext, useEffect, useState, useRef } from "react";
import { toast } from "react-toastify";
import styles from "./DashboardHeader.module.css";
import images from "../../../assets/images/index";
import ProfileDropdown from "../dropdown/profile-dropdown/ProfileDropdown";
import { CircularProgress, Dialog, Menu } from "@mui/material";
import { GrClose } from "react-icons/gr";
import { IoMdNotificationsOutline, IoMdSettings } from "react-icons/io";
import { MdMenu } from "react-icons/md";
import SearchDropdown from "../dropdown/search-dropdown/SearchDropdown";
import NotificationComponent from "../notification/NotificationComponent";
import { globalContext } from "../../../Provider/AppProvider";
import { useLazyQuery } from "@apollo/client";
import { GLOABAL_SEARCH, GLOABAL_SEARCH_BY_LOGITIX_USER, GLOABAL_SEARCH_BY_Marketing_USER } from "./api/SearchUserandTickets";
import PopupComponent from "../success-popup/PopupComponent";
import { CustomPaperComponent, roles } from "../../../helper";
import { useLocation, useNavigate } from "react-router-dom";
import ChangePassword from "../change-password/ChangePassword";

interface headerProps {
  loadingUserProfile: boolean;
  onMenuClick?: () => void;
  isSidebarOpen?: boolean;
}

interface NotificationSettings {
  statusChanges: {
    pending: boolean;
    confirmed: boolean;
    fulfilled: boolean;
    cancelled: boolean;
    refunded: boolean;
  };
  toastDuration: number;
  soundEnabled: boolean;
  soundTone: string;
  bulkUpdatesPeriod: string;
  newOrdersStatus: string;
}

const DashboardHeader: FunctionComponent<headerProps> = ({ loadingUserProfile, onMenuClick }) => {
  const { searchIcon, notificationIcon, DefaultProfile } = images;
  const [anchorEl, setAnchorEl] = useState(null);
  const { globalState, handleGlobalState } = useContext<any>(globalContext);
  const [showNotificationPopup, setShowNotificationPopup] = useState(false);
  const [showSettingsPopup, setShowSettingsPopup] = useState(false);
  const notificationRef = useRef<HTMLDivElement>(null);
  const settingsRef = useRef<HTMLDivElement>(null);
  const notificationButtonRef = useRef<HTMLDivElement>(null);
  const settingsButtonRef = useRef<HTMLDivElement>(null);
  const lastPlayedNotificationRef = useRef("");
  const [searchText, setSearchText] = useState<string>("");
  const [showSearch, setShowSearch] = useState<boolean>(false);
  const [searchResult, setSearchResult] = useState<any>("");
  const [finalsearch, setFinalsearch] = useState<string>("");
  const [userProfile, setUserProfile] = useState<string>("");
  const baseURL = process.env.REACT_APP_FRONTEND_URL;
  const [email, setEmail] = useState<boolean>(false);
  const StyledComponent = CustomPaperComponent();
  const [openSuccessDialog, setOpenSuccessDialog] = useState<boolean>(false);
  const [openDialog, setOpenDialog] = useState(false);
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const showStaffNotifications = [roles.ADMIN, roles.SUB_ADMIN, roles.MARKETING_USER].includes(
    globalState?.profile?.userRole,
  );

  // Audio context for sounds
  const audioContextRef = useRef<AudioContext | null>(null);
  const currentOscillatorRef = useRef<OscillatorNode | null>(null);
  const currentGainRef = useRef<GainNode | null>(null);

  const stopCurrentSound = () => {
    if (currentOscillatorRef.current) {
      try {
        currentOscillatorRef.current.stop();
      } catch (e) {}
      currentOscillatorRef.current = null;
      currentGainRef.current = null;
    }
  };

  const playBeep = (
    frequency: number,
    duration: number = 1.5,
    volume: number = 0.25,
    type: OscillatorType = "triangle"
  ) => {
    try {
      const AudioContextClass =
        window.AudioContext || (window as any).webkitAudioContext;

      if (!audioContextRef.current) {
        audioContextRef.current = new AudioContextClass();
      }

      const audioContext = audioContextRef.current;

      const oscillator = audioContext.createOscillator();
      const gainNode = audioContext.createGain();

      oscillator.connect(gainNode);
      gainNode.connect(audioContext.destination);

      oscillator.type = type;
      oscillator.frequency.value = frequency;

      gainNode.gain.setValueAtTime(volume, audioContext.currentTime);

      gainNode.gain.exponentialRampToValueAtTime(
        0.0001,
        audioContext.currentTime + duration
      );

      if (audioContext.state === "suspended") {
        audioContext.resume();
      }

      oscillator.start();
      oscillator.stop(audioContext.currentTime + duration);
    } catch (err) {
      console.log(err);
    }
  };

  const playSoundPreview = (tone: string) => {
    if (!notificationSettings.soundEnabled) return;

    switch (tone) {
      case "gentle-chime":
        playBeep(523, 1.2, 0.22, "triangle");
        setTimeout(() => playBeep(659, 1.2, 0.22, "triangle"), 400);
        setTimeout(() => playBeep(784, 1.5, 0.22, "triangle"), 800);
        break;

      case "alert-beep":
        playBeep(950, 0.8, 0.35, "square");
        setTimeout(() => playBeep(950, 0.8, 0.35, "square"), 900);
        setTimeout(() => playBeep(950, 0.8, 0.35, "square"), 1800);
        break;

      case "soft-bell":
        playBeep(620, 3, 0.28, "sine");
        break;

      case "quick-ping":
        playBeep(1200, 0.6, 0.30, "triangle");
        setTimeout(() => playBeep(980, 0.6, 0.25, "triangle"), 300);
        break;

      case "urgent-alarm":
        playBeep(880, 0.7, 0.4, "square");
        setTimeout(() => playBeep(660, 0.7, 0.4, "square"), 700);
        setTimeout(() => playBeep(880, 0.7, 0.4, "square"), 1400);
        setTimeout(() => playBeep(660, 0.7, 0.4, "square"), 2100);
        break;

      default:
        playBeep(700, 1.5, 0.25, "triangle");
    }
  };

  const playNotificationSound = (tone: string) => {
    if (!notificationSettings.soundEnabled) return;
    playSoundPreview(tone);
  };

  const [notificationSettings, setNotificationSettings] = useState<NotificationSettings>({
    statusChanges: {
      pending: true,
      confirmed: true,
      fulfilled: true,
      cancelled: true,
      refunded: true,
    },
    toastDuration: 5,
    soundEnabled: true,
    soundTone: "gentle-chime",
    bulkUpdatesPeriod: "All",
    newOrdersStatus: "all",
  });

  const open = Boolean(anchorEl);

  const [globalSearch] = useLazyQuery(GLOABAL_SEARCH, { fetchPolicy: "no-cache", onCompleted: (data) => setSearchResult(data) });
  const [globalSearchByLogitixUser] = useLazyQuery(GLOABAL_SEARCH_BY_LOGITIX_USER, { fetchPolicy: "no-cache", onCompleted: (data) => setSearchResult(data) });
  const [globalSearchByMarketingUser] = useLazyQuery(GLOABAL_SEARCH_BY_Marketing_USER, { fetchPolicy: "no-cache", onCompleted: (data) => setSearchResult(data) });

  const handleClick = (event: any) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleNotificationClick = () => {
    setShowNotificationPopup(!showNotificationPopup);
    setShowSettingsPopup(false);
  };

  const handleSettingsClick = () => {
    setShowSettingsPopup(!showSettingsPopup);
    setShowNotificationPopup(false);
  };

  const handleClosePopups = () => {
    setShowNotificationPopup(false);
    setShowSettingsPopup(false);
    stopCurrentSound();
  };

  const handleCloseDialogPop = () => {
    setOpenSuccessDialog(false);
    navigate("/login");
  };
  const handleCloseDialog = () => setOpenDialog(false);

  const handleStatusChange = (status: keyof NotificationSettings["statusChanges"]) => {
    setNotificationSettings((prev) => ({
      ...prev,
      statusChanges: { ...prev.statusChanges, [status]: !prev.statusChanges[status] },
    }));
  };

  const handleToastDurationChange = (duration: number) => {
    setNotificationSettings((prev) => ({ ...prev, toastDuration: duration }));
  };

  const handleSoundToggle = () => {
    setNotificationSettings((prev) => ({ ...prev, soundEnabled: !prev.soundEnabled }));
    if (notificationSettings.soundEnabled) stopCurrentSound();
  };

  const handleSoundToneChange = (tone: string) => {
    setNotificationSettings((prev) => ({ ...prev, soundTone: tone }));
    playSoundPreview(tone);
  };

  const handleBulkUpdatesChange = (period: string) => {
    setNotificationSettings((prev) => ({ ...prev, bulkUpdatesPeriod: period }));
  };

  const handleNewOrdersStatusChange = (status: string) => {
    setNotificationSettings((prev) => ({ ...prev, newOrdersStatus: status }));
  };

  // Resume audio context on user interaction
  useEffect(() => {
    const resumeAudio = () => {
      if (audioContextRef.current?.state === "suspended") {
        audioContextRef.current.resume().catch(() => undefined);
      }
    };
    window.addEventListener("pointerdown", resumeAudio, { once: true });
    window.addEventListener("keydown", resumeAudio, { once: true });
    return () => {
      window.removeEventListener("pointerdown", resumeAudio);
      window.removeEventListener("keydown", resumeAudio);
    };
  }, []);

  // FIXED: Only play sound and show toast when notification popup is open
  useEffect(() => {
    const token = globalState.notification.newNotification;
    // Only show alert when notification popup is open
    if (!token || token === lastPlayedNotificationRef.current || !showNotificationPopup) return;
    lastPlayedNotificationRef.current = token;

    if (notificationSettings.soundEnabled) {
      playNotificationSound(notificationSettings.soundTone);
    }

    toast.info("New notification received", {
      toastId: token,
      position: "top-right",
      autoClose: notificationSettings.toastDuration * 1000,
      pauseOnHover: true,
      draggable: true,
      closeOnClick: true,
    });
  }, [globalState.notification.newNotification, notificationSettings.soundEnabled, notificationSettings.soundTone, notificationSettings.toastDuration, showNotificationPopup]);

  // Cleanup audio on unmount
  useEffect(() => {
    return () => {
      stopCurrentSound();
      if (audioContextRef.current) audioContextRef.current.close();
    };
  }, []);

  // Click outside handlers
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (notificationRef.current && !notificationRef.current.contains(event.target as Node) &&
          notificationButtonRef.current && !notificationButtonRef.current.contains(event.target as Node)) {
        setShowNotificationPopup(false);
      }
      if (settingsRef.current && !settingsRef.current.contains(event.target as Node) &&
          settingsButtonRef.current && !settingsButtonRef.current.contains(event.target as Node)) {
        setShowSettingsPopup(false);
        stopCurrentSound();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSearch = async (searchString: string) => {
    if (searchString.includes("@")) setEmail(true);
    if (searchString.trim().length > 2 && !globalState.notification.notificationClicked && !globalState.error.errorClicked) {
      setShowSearch(true);
      if (globalState.profile.userRole === roles.ADMIN || globalState.profile.userRole === roles.AFFILIATER_ADMIN) {
        globalSearch({ variables: { searchText: `${searchString.trim()}%`, searchEvent: `%${searchString.trim()}%` } });
      } else if (globalState.profile.userRole === "marketing_user") {
        globalSearchByMarketingUser({ variables: { searchText: `${searchString.trim()}%`, searchEvent: `%${searchString.trim()}%` } });
      } else {
        globalSearchByLogitixUser({ variables: { searchText: `${searchString.trim()}%`, searchEvent: `%${searchString.trim()}%` } });
      }
    } else {
      const tempstate = { ...globalState };
      tempstate.globalSearch.searchtext = "";
      handleGlobalState(tempstate);
      setSearchResult([]);
      setShowSearch(false);
    }
  };

  useEffect(() => {
    setUserProfile(globalState?.profile?.photo);
  }, [globalState?.profile?.profileUpdate, globalState?.profile?.photo]);

  const handleSearchClick = (data: any) => {
    if (searchText.includes("@")) {
      setSearchText(data?.u_email_id || data?.a_email_id);
      setFinalsearch(data?.u_email_id || data?.a_email_id);
    } else {
      setSearchText(data?.u_full_name || data?.e_name || data?.lc_name || data?.user?.u_full_name);
      setFinalsearch(data?.u_full_name || data?.e_name || data?.lc_name || data?.user?.u_full_name);
    }
    setShowSearch(false);
    setEmail(false);
  };

  useEffect(() => {
    const tempState = { ...globalState };
    handleGlobalState(tempState);
  }, [globalState.notification.reSettingNotificationCount]);

  useEffect(() => {
    const tempstate = { ...globalState };
    tempstate.globalSearch.searchtext = finalsearch;
    handleGlobalState(tempstate);
  }, [finalsearch]);

  const handleCancel = () => {
    const tempState = { ...globalState };
    setSearchText("");
    setShowSearch(false);
    setFinalsearch("");
    setEmail(false);
    tempState.affiliateNumberOfUsers.numberOfUsers = null;
    tempState.globalSearch.searchtext = "";
    tempState.notification.text = "";
    tempState.notification.notificationClicked = false;
    tempState.notification.tp_id_array = null;
    tempState.notification.ticketId = null;
    tempState.notification.tpId = null;
    tempState.notification.notificationSearchCancel = !globalState.notification.notificationSearchCancel;
    tempState.error.text = "";
    tempState.error.errorClicked = false;
    tempState.error.approximateTpArray = null;
    tempState.error.ticketPlacementId = null;
    tempState.error.userError = false;
    tempState.soldTickets.emailId = "";
    tempState.soldTickets.failed = false;
    handleGlobalState(tempState);
  };

  useEffect(() => {
    setSearchText(globalState.globalSearch.searchtext);
  }, [globalState.globalSearch.searchtext]);

  useEffect(() => {
    if (globalState.notification.text) {
      setSearchText(globalState.notification.text);
      const tempState = { ...globalState };
      tempState.globalSearch.searchtext = globalState.notification.text;
      handleGlobalState(tempState);
    } else if (globalState.error.text) {
      setSearchText(globalState.error.text);
      const tempState = { ...globalState };
      tempState.globalSearch.searchtext = globalState.error.text;
      handleGlobalState(tempState);
    } else {
      setSearchText("");
    }
  }, [globalState.notification.text, globalState.error.text]);

  useEffect(() => {
    if (searchText !== globalState.notification.text && globalState.notification.notificationClicked) {
      const tempState = { ...globalState };
      tempState.notification.text = "";
      tempState.notification.notificationClicked = false;
      tempState.notification.tp_id_array = null;
      tempState.notification.ticketId = null;
      tempState.notification.tpId = null;
      tempState.notification.notificationSearchCancel = !globalState.notification.notificationSearchCancel;
      handleGlobalState(tempState);
    } else if (searchText !== globalState.error.text && globalState.error.errorClicked) {
      const tempState = { ...globalState };
      tempState.error.text = "";
      tempState.error.errorClicked = false;
      tempState.error.approximateTpArray = null;
      tempState.error.ticketPlacementId = null;
      tempState.error.status = "";
      handleGlobalState(tempState);
    }
  }, [searchText]);

  const [isMobile, setIsMobile] = useState(
    window.innerWidth <= 768
  );

  return (
    <div className={styles.dashboardHeader} style={{ display: `${pathname === "/new-list" ? "none" : ""}` }}>
      {/* Hamburger Menu - only mobile */}
      <div
        className={styles.menuIconContainer}
        onClick={onMenuClick}
      >
        <MdMenu
          className={styles.hamburgerIcon}
          size={24}
        />
      </div>

      {/* Right side: Notification, Settings, Profile */}
      <div className={styles.profileAndNotification}>
        <div className={styles.iconButtons}>
          {/* Notification Icon */}
          {showStaffNotifications && (
            <div className={styles.iconWrapper} onClick={handleNotificationClick} ref={notificationButtonRef}>
              <div className={styles.iconContainer}>
                <IoMdNotificationsOutline className={styles.notificationIcon} size={22} />
                {(globalState.notificationCount.past > 0 || globalState.notificationCount.recent > 0) && (
                  <div className={styles.notificationBadge} />
                )}
              </div>
            </div>
          )}

          {/* Settings Icon */}
          <div className={styles.iconWrapper} onClick={handleSettingsClick} ref={settingsButtonRef}>
            <IoMdSettings className={styles.settingsIcon} size={22} />
          </div>
        </div>

        {/* Custom Notification Popup */}
        {showStaffNotifications && showNotificationPopup && (
          <div className={styles.customPopup} ref={notificationRef}>
            <div className={styles.popupHeader}>
              <h3>Notifications</h3>
              <button className={styles.closeBtn} onClick={handleClosePopups}>×</button>
            </div>
            <div className={styles.popupContent}>
              <NotificationComponent
                closePopup={handleClosePopups}
                preferredPeriod={notificationSettings.bulkUpdatesPeriod as "30D" | "90D" | "12M" | "All"}
                statusFilters={notificationSettings.statusChanges}
              />
            </div>
          </div>
        )}

        {/* Custom Settings Popup */}
        {showSettingsPopup && (
          <div className={styles.customPopup} ref={settingsRef}>
            <div className={styles.popupHeader}>
              <h3>Notification Preferences</h3>
              <button className={styles.closeBtn} onClick={handleClosePopups}>×</button>
            </div>
            <div className={styles.popupContent}>
              {/* Status Changes Section */}
              <div className={styles.settingsSection}>
                <div className={styles.sectionTitle}>Status Changes</div>
                <div className={styles.settingRow}>
                  <label className={styles.settingLabel}>Bulk Updates</label>
                  <div className={styles.periodGroup}>
                    {["30D", "90D", "12M", "All"].map((period) => (
                      <button
                        key={period}
                        className={`${styles.periodBtn} ${notificationSettings.bulkUpdatesPeriod === period ? styles.active : ""}`}
                        onClick={() => handleBulkUpdatesChange(period)}
                      >
                        {period}
                      </button>
                    ))}
                  </div>
                </div>
                <div className={styles.settingRow}>
                  <label className={styles.settingLabel}>New Orders</label>
                  <div className={styles.statusGroup}>
                    <button
                      className={`${styles.statusBtn} ${notificationSettings.newOrdersStatus === "all" ? styles.active : ""}`}
                      onClick={() => handleNewOrdersStatusChange("all")}
                    >
                      All Users
                    </button>
                  </div>
                </div>
                <div className={styles.settingRow}>
                  <label className={styles.settingLabel}>Status Transitions</label>
                  <div className={styles.toggleGroup}>
                    {(["pending", "confirmed", "fulfilled", "cancelled", "refunded"] as const).map((status) => (
                      <label key={status} className={styles.toggleItem}>
                        <span>{status.charAt(0).toUpperCase() + status.slice(1)}</span>
                        <div className={styles.toggleSwitch}>
                          <input
                            type="checkbox"
                            checked={notificationSettings.statusChanges[status]}
                            onChange={() => handleStatusChange(status)}
                          />
                          <span className={styles.toggleSlider}></span>
                        </div>
                      </label>
                    ))}
                  </div>
                </div>
              </div>

              <div className={styles.divider} />

              {/* Toast Pop-ups Section */}
              <div className={styles.settingsSection}>
                <div className={styles.sectionTitle}>Toast Pop-ups</div>
                <div className={styles.settingRow}>
                  <label className={styles.settingLabel}>Show toast alerts</label>
                  <div className={styles.durationGroup}>
                    {[3, 5, 10].map((duration) => (
                      <button
                        key={duration}
                        className={`${styles.durationBtn} ${notificationSettings.toastDuration === duration ? styles.active : ""}`}
                        onClick={() => handleToastDurationChange(duration)}
                      >
                        {duration}s
                      </button>
                    ))}
                  </div>
                </div>
              </div>

              <div className={styles.divider} />

              {/* Sound Alert Section */}
              <div className={styles.settingsSection}>
                <div className={styles.sectionTitle}>Sound Alert</div>
                <div className={styles.settingRow}>
                  <div className={styles.soundHeader}>
                    <span>Sound for new pending orders</span>
                    <div className={styles.toggleSwitch}>
                      <input type="checkbox" checked={notificationSettings.soundEnabled} onChange={handleSoundToggle} />
                      <span className={styles.toggleSlider}></span>
                    </div>
                  </div>
                </div>
                {notificationSettings.soundEnabled && (
                  <div className={styles.soundTones}>
                    {["gentle-chime", "alert-beep", "soft-bell", "quick-ping", "urgent-alarm"].map((tone) => (
                      <button
                        key={tone}
                        className={`${styles.toneBtn} ${notificationSettings.soundTone === tone ? styles.active : ""}`}
                        onClick={() => handleSoundToneChange(tone)}
                      >
                        <span>{tone.replace("-", " ").replace(/\b\w/g, (l) => l.toUpperCase())}</span>
                        <span className={styles.previewText}>Preview</span>
                      </button>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {/* Profile Section */}
        {loadingUserProfile ? (
          <div className={styles.profileCircularProgress}>
            <CircularProgress color="primary" size={30} />
          </div>
        ) : (
          <div className={styles.profile} data-testid="profileClick" onClick={handleClick}>
            <div className={styles.profileOuterCircle}>
              <img className={styles.imgIcon} alt="userProfile" src={DefaultProfile} />
            </div>
            <div className={styles.userName}>
              {globalState?.profile?.firstName} {globalState?.profile?.lastName}
            </div>
          </div>
        )}
      </div>

      {/* Dropdown Menu for Profile */}
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        transformOrigin={{ horizontal: "left", vertical: "top" }}
        anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
        MenuListProps={{ disablePadding: true }}
      >
        <ProfileDropdown handleClose={handleClose} setOpenSuccessDialog={setOpenSuccessDialog} setOpenDialog={setOpenDialog} />
      </Menu>

      <Dialog
        open={openSuccessDialog}
        onClose={(_event, reason) => {
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
          handleCloseDialogPop();
        }}
        PaperComponent={StyledComponent}
      >
        <PopupComponent
          handleClose={handleCloseDialogPop}
          title="Password Updated"
          subTitle="Your password has been successfully updated. Please sign in to your account."
        />
      </Dialog>
      <Dialog open={openDialog} classes={{ paper: styles.customDialog }}>
        <ChangePassword handleCloseDialog={handleCloseDialog} setOpenSuccessDialog={setOpenSuccessDialog} />
      </Dialog>
    </div>
  );
};

export default DashboardHeader;